// Root options for ReactDOM.createRoot (src/index.js and src/index_mobile.js).
//
// React 19 reports an error that an error boundary CAUGHT through
// root.onCaughtError, whose default is console.error(error) -- and it runs
// BEFORE the boundary's componentDidCatch. The app installs Sentry's console
// integration (captureConsoleIntegration, levels: error), so that call captured
// the Error object first and marked it; the Sentry ErrorBoundary's own capture
// of the same object -- the one carrying the section-crash tag and the shape
// context from ChatNoteSectionBody's beforeCapture (#2753) -- was deduplicated
// and never sent. The boundary still got an eventId back, which is what the
// on-screen "Reference" printed: an id that never existed in Sentry, and why
// `has:note.sectionCrash` stayed empty through every crash report.
//
// So a caught error is NOT re-logged as console.error here. Every boundary in
// the app reports on its own: Sentry's ErrorBoundary captures with its tags
// (App, Home, Settings, Modal, ChatNoteSection, ChatNoteSectionBody) and
// PeptideErrorBoundary logs explicitly. Outside production the error is still
// surfaced for the developer, as a warning -- a level the console integration
// does not capture. One knock-on: the mobile WebView's forward of every
// console.error to the native shell no longer fires for boundary-caught errors;
// the tagged Sentry event is the report for those. onUncaughtError and
// onRecoverableError keep React's defaults (reportError -> window "error" ->
// Sentry's global handlers).
export function onCaughtError(error, errorInfo) {
  if (process.env.NODE_ENV === "production") return;
  console.warn("Caught by an error boundary (the boundary reports it):", error, errorInfo?.componentStack);
}

export const reactRootOptions = { onCaughtError };
